import "core-js/modules/es.array.includes.js";
import React from 'react';
import { Title } from './partials';
export var SubsectionTitle = function SubsectionTitle(_ref) {
  var title = _ref.title,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? false : _ref$marginTop,
    _ref$withBar = _ref.withBar,
    withBar = _ref$withBar === void 0 ? true : _ref$withBar,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'left' : _ref$align;
  return React.createElement(Title, {
    marginTop: marginTop
  }, withBar && ['center'].includes(align) && React.createElement("span", null), React.createElement("h3", null, title), withBar && React.createElement("span", null));
};